<template>
  <IconLucideFolderPen />
</template>
